<template>
  <article class="product-card">
    <router-link :to="detailRoute" class="product-image-wrap">
      <img :src="product.image" :alt="product.name">
    </router-link>
    <div class="product-card-body">
      <router-link :to="detailRoute" class="product-name">{{ product.name }}</router-link>
      <p>{{ product.color }}</p>
      <div class="price-row">
        <strong>${{ product.price.toFixed(2) }}</strong>
        <del v-if="product.oldPrice">${{ product.oldPrice.toFixed(2) }}</del>
      </div>
      <button @click="quickAdd">Quick Add</button>
    </div>
  </article>
</template>

<script>
import { addToCart } from '@/utils/cart'

export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    detailRoute() {
      const seed = `${this.product.id || ''}${this.product.name || ''}`
        .split('')
        .reduce((total, char) => total + char.charCodeAt(0), 0)
      const item = `GP${String(seed % 100000).padStart(5, '0')}`
      const ref = ['new-arrivals', 'category-grid', 'style-edit'][seed % 3]

      return {
        path: `/items/p/${this.product.id}`,
        query: {
          item,
          ref,
          v: String((seed * 37) % 9000 + 1000)
        }
      }
    }
  },
  methods: {
    quickAdd() {
      addToCart(this.product)
      this.$message.success('Added to bag')
    }
  }
}
</script>
